import { render } from "./thankyou.vue?vue&type=template&id=54c5aaa0&scoped=true"
import script from "./thankyou.vue?vue&type=script&lang=js"
export * from "./thankyou.vue?vue&type=script&lang=js"

import "./thankyou.vue?vue&type=style&index=0&id=54c5aaa0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c5aaa0"]])

export default __exports__